module.exports = __webpack_public_path__ + "media/images/official/plan_ticket_icon5-be2ba3abb028a9a89f44927814fdd39f.svg";